var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLookProfessionalBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3V2a2 2 0 012-2h4a2 2 0 012 2v1h3a1 1 0 011 1v9a1 1 0 01-1 1H1a1 1 0 01-1-1V4a1 1 0 011-1h3zm1 0h6V2a1 1 0 00-1-1H6a1 1 0 00-1 1v1zm10 1H1v3h3V6h1v1h6V6h1v1h3V4zM1 8v5h14V8h-3v1h-1V8H5v1H4V8H1z",
    fill: "#162D3D"
  })));
}

export default "data:image/svg+xml,%3csvg width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 3V2C4 0.89543 4.89543 0 6 0H10C11.1046 0 12 0.89543 12 2V3H15C15.5523 3 16 3.44772 16 4V13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13V4C0 3.44772 0.447715 3 1 3H4ZM5 3H11V2C11 1.44772 10.5523 1 10 1H6C5.44772 1 5 1.44772 5 2V3ZM15 4H1V7H4V6H5V7H11V6H12V7H15V4ZM1 8V13H15V8H12V9H11V8H5V9H4V8H1Z' fill='%23162D3D'/%3e %3c/svg%3e";
export { SvgLookProfessionalBusiness as ReactComponent };